import { FormCheck, FormControl, InputGroup } from "react-bootstrap";
import styled from "styled-components";

const StyledHeader = styled.div`
    margin-top: 34px;
    margin-bottom: 24px;
`;

const StyledFlexDiv = styled.div`
    display: flex;
`;

const StyledSpaceBetweenDiv = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledFlexEndDiv = styled.div<{ margin?: number; width?: number }>`
    display: flex;
    justify-content: flex-end;
    margin-top: ${({ margin }) => (margin ? `${margin}px` : 0)};
    max-width: ${({ width }) => (width ? `${width}px` : `100%`)};
`;

const StyledCenterDiv = styled.div<{ margin?: number }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: ${({ margin }) => (margin ? `${margin}px` : 0)};
`;

const StyledP = styled.p`
    margin: 0;
`;

const StyledTextP = styled.p`
    font-size: 15px;
    font-weight: 400;
`;

const StyledTitle = styled.h1`
    font-weight: 700;
    font-size: 36px;
    line-height: 130%;
    display: flex;
    align-items: center;
    margin: 0;
    mix-blend-mode: normal;
`;

const StyledSubTitle = styled.h3`
    font-size: 17px;
    line-height: 21px;
    color: #383838;
    padding-bottom: 16px;
    margin: 0px;
    margin-top: 1rem;
`;

const StyledBody = styled.div`
    padding-top: 0;
`;

const StyledLabel = styled.label<{ marginB?: number }>`
    font-size: 15px;
    line-height: 21px;
    margin: 0;
    margin-bottom: ${({ marginB }) => (marginB ? `${marginB}px` : `16px`)};
`;

const StyledFormCheck = styled(FormCheck)`
    .form-check {
        display: flex;
        align-items: center;
    }
    .form-check-input {
        width: 21px;
        height: 21px;
        vertical-align: middle;
        border: 1px solid #9654ff;
        border-radius: 3px;
        background-color: transparent;
        box-shadow: none;
        margin: inherit;
        cursor: pointer;
        &:checked {
            background-color: #9654ff;
            box-shadow: none;
        }
    }
    .form-check-label {
        padding-left: 1.25rem;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        color: #404040;
    }
`;

const StyledFormCheckNotification = styled(FormCheck)`
    .form-check {
        display: flex;
        align-items: center;
    }
    .form-check-input {
        width: 21px;
        height: 21px;
        vertical-align: middle;
        border: 1px solid #8a0538;
        border-radius: 3px;
        background-color: transparent;
        box-shadow: none;
        margin: inherit;
        &:checked {
            background-color: #8a0538;
            box-shadow: none;
        }
    }
    .form-check-label {
        padding-left: 1.25rem;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        color: #404040;
    }
`;

const StyledInputGroupSearch = styled(InputGroup)`
    border-radius: 4px !important;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    transition-timing-function: ease !important;
    transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1) !important;
    width: 100%;
    border: 1px solid #fff !important;
    &:hover {
        border: 1px solid #9654ff !important;
    }
    &:active {
        border: 1px solid #9654ff !important;
    }
    &:focus {
        border: 1px solid #9654ff !important;
    }
    &:focus-visible {
        border: 1px solid #9654ff !important;
        outline: none;
    }
`;

const StyledInputGroupTextSearch = styled(InputGroup.Text)`
    background-color: #ffff;
    border-style: solid;
    border-color: #787878;
    border: none;
`;
const StyledFormControlSearch = styled(FormControl)`
    border: none !important;
    width: 100%;
    border-radius: 4px;
`;

export {
    StyledHeader,
    StyledTitle,
    StyledSubTitle,
    StyledBody,
    StyledLabel,
    StyledFormCheck,
    StyledInputGroupSearch,
    StyledInputGroupTextSearch,
    StyledFormControlSearch,
    StyledFormCheckNotification,
    StyledFlexDiv,
    StyledP,
    StyledCenterDiv,
    StyledFlexEndDiv,
    StyledSpaceBetweenDiv,
    StyledTextP,
};
